import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {Subject} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PatientService} from '../../Services/patient.service';
import {InsuranceService} from '../../Services/insurance.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import * as $ from 'jquery';
import {debounceTime, first} from 'rxjs/operators';
import {isDateLike, formatDateString} from '../../Model/utils';
import {format, isValid, parse} from 'date-fns';
import swal from 'sweetalert2';
import {HttpResponse} from '@angular/common/http';
import {Sort} from '@angular/material/sort';
import {ProviderService} from '../../Services/provider.service';
import {UserService} from "../../Services/UserService";

interface hmoListPage {
  page: number;        // API uses 1-based index
  size: number;        // Page size
  currentPage: number; // MatPaginator uses 0-based index
}

interface tableListPage {
  page: number;        // API uses 1-based index
  size: number;        // Page size
  currentPage: number; // MatPaginator uses 0-based index
}

@Component({
  selector: 'pm-hmo',
  templateUrl: './hmo.component.html',
  styleUrls: ['./hmo.component.css']
})

export class HmoComponent implements OnInit, AfterViewInit {

  hmoForm!: FormGroup;
  OfficeType: any = [];
  selectedOfficeId: number | null = null;
  searchText = '';
  searchPayor = '';
  selectedpayorId: any = null;
  tablePayerData: any = [];
  tableData: any = [];
  sortedData: any[] = [];
  sortField: string;
  sortDirection: 'asc' | 'desc' | null = null;
  phoneType: any = [
    {value: 'Mobile', viewValue: 'Mobile'},
    {value: 'Work', viewValue: 'Work'},
    {value: 'Home', viewValue: 'Home'},
  ];
  pagination: hmoListPage = {
    page: 1,         // API uses 1-based index
    size: 10,        // Default page size
    currentPage: 0   // MatPaginator uses 0-based index
  };

  paginationPayer: tableListPage = {
    page: 1,         // API uses 1-based index
    size: 10,        // Default page size
    currentPage: 0   // MatPaginator uses 0-based index
  };

  totalPagesArray: any[] = [];
  totalPayerPagesArray: any[] = [];
  payerArray: any[] = [
    { id: 1, name: "1199 National Benefit Fund of NY (PO Box 1149)", payerIdCode: "13551" },
    // Add more items to simulate large dataset
    ...Array.from({ length: 1356 }, (_, i) => ({ id: i + 2, name: `Payer ${i + 2}` }))
  ];
  filterPayerArray: any[] = [...this.payerArray];
  totalRecord: any;
  totalPayerRecord: any;
  searchString: any = null;
  selectedType = 2;
  showMonthFilter = false;
  selectedMonth: Date | null = null;
  todaysDate: Date = new Date();
  tStartDate: Date = new Date();
  tEndDate: Date = new Date();
  ignoreDocumentClick = false;
  lastUsedFilterParams: any = {};
  errorMessages: any;
  errorMessagePart: any;
  files: File[] = [];
  fileImage: string | null = null;
  isDragOver = false;
  selectedPayerId: any = null;
  uploadDate: Date = new Date();
  payerSortField: string | null = null;
  payerSortDirection: 'asc' | 'desc' | null = null;
  private clientSub: any;
  private subject: Subject<string> = new Subject();
  @ViewChild('fileDropRef') fileDropRef!: ElementRef;
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild('searchBox') searchValue!: ElementRef;
  @ViewChild('filterDropdown') filterDropdown: ElementRef;
  @ViewChild('filterBtn') filterBtn: ElementRef;
  @ViewChild('bulkUpload') bulkUploadModal!: ElementRef;
  @ViewChild('table') tableModal!: ElementRef;

  constructor(private fb: FormBuilder,
              private patientServices: PatientService,
              private insuranceServices: InsuranceService,
              private userServices: UserService,
              public authService: AuthService,
              private router: Router,
              private datePipe: DatePipe,
              private renderer: Renderer2,
              private providerServices: ProviderService,
              private patientService: PatientService,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone) {
    this._setSearchSubscription();
    this.hmoForm = this.fb.group({
      officeId: [null],
    });
  }

  ngOnInit(): void {
    // Retrieve the last visited page from session storage
    const savedFilters = sessionStorage.getItem('lastUsedFilterParams');
    // if (savedFilters) {
    //   this.lastUsedFilterParams = JSON.parse(savedFilters);
    //   this.startDate = new Date(this.lastUsedFilterParams.startDate);
    //   this.endDate = new Date(this.lastUsedFilterParams.endDate);
    // }
    this.loadPaginationState();
    this.calculateTotalPages(); // Remove pagination state on reload
    this.calculatePayerTotalPages();
    // this._fetchData();
    this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
      if (clientId) {
        this.pagination.page = 1;
        this.pagination.currentPage = 1;
        this.lastUsedFilterParams = null;
        this._fetchData();
      }
    })
    this.getPayer();
    // this.sortedData = [...this.tableData];
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('hmoListPage');
      sessionStorage.removeItem('tableListPage');
    });

    const params = {
      isOfficeNameAndId: true,
      clientId: this.authService.clientId
    };
    this.providerServices.getAllOffice(params).pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          this.OfficeType = response;
          this.selectedOfficeId = response[0].id; // default to first office
          this._fetchData(); // initial fetch
        }
      });

    // this.router.navigate(['userworkarea/'], { state: { from: this.router.url } });
  }
  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }

  ngAfterViewInit() {
    /*  if (this.paginator) {
        this.paginator.pageIndex = this.currentPage - 1;  // Assign paginator to data source
        this.tableData.paginator = this.paginator;

        // Initialize Bootstrap popovers globally
        ($('[data-toggle="popover"]') as any).popover();
      }*/
    if (this.paginator) {
      this.paginator.pageIndex = this.pagination.currentPage; // Restore page index
      this.paginator.pageIndex = this.paginationPayer.currentPage;
      ($('[data-toggle="popover"]') as any).popover();
    }
  }

  formatStartOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }

  formatEndOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(23, 59, 59, 999);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }


  onKeyUp(event: any): void {
    const searchTextValue = event.target.value.trim();
    this.subject.next(searchTextValue);

    if (searchTextValue === '') {
      this.searchString = '';  // Reset searchString
      this.pagination.currentPage = 1;   // Ensure page is reset
      this._fetchData();  // Fetch full listing
    }
  }

  /*scrollToSelectedPayer(insuranceProvider: string) {
    if (!insuranceProvider || !this.virtualScrollViewport) {
      return;
    }

    const index = this.payerArray.findIndex((payer) => payer.id.toString() === insuranceProvider.toString());
    if (index > -1) {
      setTimeout(() => {
        this.virtualScrollViewport.scrollToIndex(index);
      });
    }
  }*/

  trackByFn(index: number, item: any) {
    return item.id;
  }

  async getPayer() {
    const paramsP = {
      isPayerNameAndId: true,
      clientId: this.authService?.clientId || null,
    };

    try {
      const response = await this.patientService.getPayer(paramsP).pipe(first()).toPromise();
      if (response) {
        this.payerArray = response;
        this.filterPayerArray = [...this.payerArray];
      }
    } catch (error) {
      this.showError(error.error?.message || 'Failed to fetch payer list');
    }
  }

  showError(message: string) {
    swal.fire({
      title: 'Error!',
      icon: 'error',
      text: message,
      showConfirmButton: false,
      timer: 5000,
    });
  }

  searchPayers() {
    const searchTextLower = this.searchPayor.toLowerCase();
    this.filterPayerArray = this.payerArray.filter((payer) =>
      payer.name.toLowerCase().includes(searchTextLower)
    );
  }

  private _setSearchSubscription(): void {
    this.subject.pipe(
      debounceTime(200)
    ).subscribe((searchValue: any) => {
      if (searchValue.trim() === '') {
        this.searchString = '';  // Reset searchString
        this.pagination.currentPage = 1;  // Reset page index before fetching
        this._fetchData(1);  // Fetch full listing
      } else {
        this.searchString = searchValue;  // Set new search value
        this.searchPatient();  // Perform search
      }
    });
  }

  onSearch() {
    let inputValue = this.searchValue.nativeElement.value.trim(); // Trim to remove extra spaces

    if (!inputValue) {
      // If input is empty, reset searchString and fetch full listing
      this.searchString = '';
      /*this.pagination.currentPage = 1; */ // Reset page index before fetching
      this._fetchData(1);  // Fetch full data
      return;
    }

    // Decode any URL-encoded characters like %20 to a normal string
    inputValue = decodeURIComponent(inputValue);

    // Use a regular expression to determine if the input looks like a date
    // const isDateLike = this.isDateLike(inputValue);

    if (isDateLike(inputValue)) {
      const formattedDate = formatDateString(inputValue);
      if (formattedDate) {
        this.searchString = formattedDate;
        this.searchPatient();
      }
    } else {
      this.searchString = inputValue;
      this.searchPatient();
    }
  }

  handleKeyUp(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;

    // Trigger search on Enter
    if (event.key === 'Enter') {
      this.onSearch();
      return;
    }

    // Existing debounce logic
    this.subject.next(value);
  }
  clearSearch(input: HTMLInputElement) {
    input.value = '';
    this.searchString = '';
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    this._fetchData(1);
  }



  setFilterType(type: string) {
    if (type === 'active') {
      this.selectedType = 2;
    } else if (type === 'inactive') {
      this.selectedType = 3;
    } else {
      this.selectedType = 1; // Default to "All"
    }
  }
  // Helper function to check if a string looks like a date
  // isDateLike(input: string): boolean {
  //   // Regular expression to check for common date patterns
  //   const datePattern = /^(\d{1,2}[-\/]\d{1,2}[-\/]\d{2,4})|(\d{4}[-\/]\d{1,2}[-\/]\d{1,2})|([A-Za-z]+\s\d{1,2},\s\d{4})$/;
  //
  //   // Test the input against the date pattern
  //   return datePattern.test(input);
  // }

  formatDateString(inputDate: string) {
    // Define possible date formats to parse the input date
    const formats = [
      'MM/dd/yyyy',
      'dd/MM/yyyy',
      'yyyy/MM/dd',
      'yyyy-MM-dd',
      'dd-MM-yyyy',
      'MM-dd-yyyy',
      'MMMM dd, yyyy',    // e.g., "October 15, 2024"
      'yyyy/MM/dd HH:mm',  // e.g., "2024/10/15 14:30"
      'MM/dd/yyyy HH:mm',  // e.g., "10/15/2024 14:30"
      'dd-MM-yyyy HH:mm',  // e.g., "15-10-2024 14:30"
    ];

    let parsedDate: Date | null = null;

    // Try parsing the input date with each format
    for (const formatStr of formats) {
      parsedDate = parse(inputDate, formatStr, new Date());
      if (isValid(parsedDate)) {
        break;  // Stop if a valid date is found
      }
    }

    // If a valid date was parsed, format it to 'MM/dd/yyyy'
    if (parsedDate && isValid(parsedDate)) {
      const formattedDate = format(parsedDate, 'MM/dd/yyyy');
      this.searchString = formattedDate; // Set the formatted date as the search string

      // Call the search function with the formatted date
      this.searchPatient();
    }
    // If no valid date is found, simply do nothing (no error message shown)
  }

  formatDate(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    return this.datePipe.transform(dateObj, 'yyyy-MM-dd');
  }

  searchPatient() {
    const search: { [key: string]: any } = {
      page: 1,
      size: this.pagination.size,
      keyword: this.searchString,
      officeId: this.selectedOfficeId,
      duplicate: false
    };
    if (this.sortField && this.sortDirection) {
      search.sort = `${this.sortField},${this.sortDirection}`;
    }
    this.insuranceServices.searchHmo(search).pipe(first()).subscribe(
      (response: any) => {
        if (response != undefined) {
          this.updateTable(response);
        }
      },
      (error) => {
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message || 'something went wrong !',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );

  }

  // pagination changes
  /*  pageChange = (obj: any) => {
      // Update currentPage based on paginator's pageIndex
      this.currentPage = obj.pageIndex + 1;  // paginator uses 0-based indexing, so we add 1
      this.size = obj.pageSize;

      // Store the current page in session storage
      sessionStorage.setItem('userWorkListPage', this.currentPage.toString());

      // Call the _fetchData method with type 1 (or as appropriate)
      this._fetchData(1);
    };*/

  pageChange(event: any): void {

    const pageSizeChanged =
      this.pagination.size !== event.pageSize;

    this.pagination.size = event.pageSize;

    this.pagination.currentPage =
      pageSizeChanged
        ? 0
        : event.pageIndex;

    this.pagination.page =
      this.pagination.currentPage + 1;

    sessionStorage.setItem(
      'hmoListPage',
      JSON.stringify(this.pagination)
    );

    this._fetchData();
  }

  payerPageChange(event: any): void {

    const pageSizeChanged =
      this.paginationPayer.size !== event.pageSize;

    this.paginationPayer.size =
      event.pageSize;

    this.paginationPayer.currentPage =
      pageSizeChanged
        ? 0
        : event.pageIndex;

    this.paginationPayer.page =
      this.paginationPayer.currentPage + 1;

    sessionStorage.setItem(
      'tableListPage',
      JSON.stringify(this.paginationPayer)
    );

    this.fetchPayerCounterData();
  }  

  private fetchPayerCounterData(): void {

    const params: { [key: string]: any } = {

      page: this.paginationPayer.page,
      size: this.paginationPayer.size,

      isPayerOfficeCount: true,

      officeId:
        this.selectedOfficeId || 1

    };

    if (
      this.payerSortField &&
      this.payerSortDirection
    ) {

      params.sort =
        `${this.payerSortField},${this.payerSortDirection}`;

    }


    this.insuranceServices
      .getHmoPayerListing(params)
      .pipe(first())
      .subscribe(

        (response: any) => {

          this.tablePayerData =
            response?.content || response || [];

          this.totalPayerRecord =
            response?.totalElements || 0;

          this.totalPayerPagesArray =
            Array.from(
              {
                length:
                  response?.totalPages || 0
              },
              (_, i) => i + 1
            );

          this.cdr.detectChanges();
        },

        (error) => {

          this.tablePayerData = [];
          this.totalPayerRecord = 0;
          this.totalPayerPagesArray = [];

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text:
              error?.error?.message ||
              'Unable to load payer counts.',
            showConfirmButton: false,
            timer: 5000
          });

        }

      );
  }  

// Handles page jump from the dropdown
  jumpToPage(event: any) {
    this.pagination.currentPage = event.value;
    this.pagination.page = this.pagination.currentPage + 1;

    this.paginationPayer.currentPage = event.value;
    this.paginationPayer.page = this.pagination.currentPage + 1;

    sessionStorage.setItem('hmoListPage', JSON.stringify(this.pagination));
    sessionStorage.setItem('tableListPage', JSON.stringify(this.paginationPayer));

    this._fetchData(1);
  }

  jumpToPayerPage(event: any): void {

    this.paginationPayer.currentPage =
      event.value;

    this.paginationPayer.page =
      event.value + 1;

    sessionStorage.setItem(
      'tableListPage',
      JSON.stringify(this.paginationPayer)
    );

    this.fetchPayerCounterData();
  }  

// Calculate total pages and update dropdown options
  calculateTotalPages() {
    const totalPages = Math.ceil(this.totalRecord / this.pagination.size);
    this.totalPagesArray = Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  calculatePayerTotalPages() {
    const totalPayerPages = Math.ceil(this.totalPayerRecord / this.paginationPayer.size);
    this.totalPayerPagesArray = Array.from({ length: totalPayerPages }, (_, i) => i + 1);
  }

// Load pagination state from session storage
  loadPaginationState() {
    const storedData = sessionStorage.getItem('hmoListPage');
    const storedPayerData = sessionStorage.getItem('tableListPage');

    if (storedData) {
      this.pagination = JSON.parse(storedData);
      this.calculateTotalPages();
    }
    if (storedPayerData) {
      this.paginationPayer = JSON.parse(storedPayerData);
      this.calculatePayerTotalPages();
    }
  }

  showPopover(button: HTMLElement) {
    ($(button) as any).popover('show');
  }

  hidePopover(button: HTMLElement) {
    ($(button) as any).popover('hide');
  }

// Method to open the modal and add background blur
  openModal(): void {

    const modalElement =
      this.bulkUploadModal?.nativeElement;

    if (!modalElement) {
      return;
    }

    modalElement.style.display = 'flex';
    modalElement.classList.add('show');
  }

  openTableModal(): void {

    this.fetchPayerCounterData();

    const modalElement =
      this.tableModal?.nativeElement;

    if (!modalElement) {
      return;
    }

    modalElement.style.display = 'flex';
    modalElement.classList.add('show');
  }

  closeBulkUploadModal(): void {

    this.errorMessages = null;
    this.errorMessagePart = null;

    this.files = [];
    this.fileImage = null;
    this.isDragOver = false;

    const modalElement =
      this.bulkUploadModal?.nativeElement;

    if (!modalElement) {
      return;
    }

    modalElement.style.display = 'none';
    modalElement.classList.remove('show');
  }

  closeTableModal(): void {

    const modalElement =
      this.tableModal?.nativeElement;

    if (!modalElement) {
      return;
    }

    modalElement.style.display = 'none';
    modalElement.classList.remove('show');
  }
  // Method to close the modal and remove background blur
  closeModal() {
    this.errorMessages = null;
    this.errorMessagePart = null;
    this.files = null;       // Optionally clear the file data as well
    this.fileImage = null;
    const modalElement = this.bulkUploadModal.nativeElement;
    const modalTElement = this.tableModal.nativeElement;
    modalTElement.style.display = 'none';
    modalTElement.classList.remove('show');
    modalElement.style.display = 'none'; // Hide modal
    modalElement.classList.remove('show'); // Remove 'show' class

    // Remove blur from the background
    this.renderer.removeClass(document.body, 'blur-background');
  }

  upload() {
    // Your upload logic here
    // console.log('Uploading...');
  }

  onFilesSelected(event: any): void {
    const selectedFiles = event.target.files;
    this.files = Array.from(selectedFiles);

    // Check if the first selected file is an Excel file
    if (this.files.length > 0) {
      const file = this.files[0];
      if (file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'text/csv' ||
        file.type === 'application/csv') {
        // Set the image for Excel files
        this.fileImage = 'assets/img/xlxs.png'; // Path to the image for Excel files
      } else if (file.type === 'application/pdf') {
        this.fileImage = 'assets/img/pdf.png'; // PDF icon
      } else {
        this.fileImage = null; // Reset if not an Excel file
      }
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    const droppedFiles = event.dataTransfer?.files;
    if (droppedFiles) {
      this.files = Array.from(droppedFiles);
      this.fileDropRef.nativeElement.files = droppedFiles; // Set files in the input

      // Check if the dropped file is an Excel file
      const file = this.files[0];

      if (file) {
        if (
          file.type === 'application/vnd.ms-excel' ||
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ) {
          this.fileImage = 'assets/img/xlxs.png'; // Excel file image
        } else if (file.type === 'application/pdf') {
          this.fileImage = 'assets/img/pdf.png'; // PDF file image
        } else {
          this.fileImage = null; // Reset for unsupported file types
        }
      }

    }
  }

  uploadFiles(): void {
    if (this.files.length) {
      const formData = new FormData();
      const params = {
        // clientId: this.authService.getClientId()
        officeId: this.selectedOfficeId || 1,
        payerId: this.selectedPayerId,
        hmoDate: this.formatDate(this.uploadDate),
        duplicate: false

      };
      for (const file of this.files) {
        formData.append('file', file, file.name);
      }

      this.insuranceServices.hmoUpload(formData, params).pipe(first()).subscribe(
        (response: any) => {
          if (response) {
            this._fetchData();
            this.closeModal();
            swal.fire({
              icon: 'success',
              text: 'Uploaded successfully.',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            this.handleErrorResponse(response);
          }
        },
        (error) => {
          this.handleErrorResponse(error.error);
        }
      );
    }
  }

  handleErrorResponse(error: any): void {
    const errorMessage = error?.message;
    const errorArray = error?.errors;

    // Case 1: Error with 'errors' array (structured validation errors)
    if (errorArray && Array.isArray(errorArray)) {
      this.errorMessagePart = errorMessage || 'Validation errors occurred';
      this.errorMessages = errorArray.map((e: any) => e.message || 'Unknown validation error');
    }
    // Case 2: Error message with "Details:"
    else if (errorMessage && errorMessage.includes('Details:')) {
      const {messagePart, detailsPart} = this.extractErrorDetails(errorMessage);
      this.errorMessagePart = messagePart;
      this.errorMessages = detailsPart;
    }
    // Fallback: Just a plain message
    else if (errorMessage) {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Fallback : string
    else if (typeof errorMessage === 'string') {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Last fallback
    else {
      this.errorMessagePart = 'An error occurred';
      this.errorMessages = [];
    }
  }

  extractErrorDetails(message: string): { messagePart: string, detailsPart: string[] } {
    const detailsStart = message.indexOf('Details:');

    if (detailsStart === -1) {
      return {messagePart: message.trim(), detailsPart: []};
    }

    // Split the main message and the detailed part
    const messagePart = message.substring(0, detailsStart).trim();
    const detailsString = message.substring(detailsStart + 8).trim();

    const detailsPart: string[] = [];

    // Match all nested brackets: [row: 1, ...], [row: 2, ...]
    const nestedDetailMatches = detailsString.match(/\[(.*?)\]/g); // Match all [ ... ] groups

    if (nestedDetailMatches) {
      nestedDetailMatches.forEach(detail => {
        const cleanDetail = detail
          .replace(/^\[|\]$/g, '') // remove outer brackets
          .trim();
        if (cleanDetail) {
          detailsPart.push(cleanDetail);
        }
      });
    } else {
      // Fallback if no brackets are found: split by comma
      detailsPart.push(...detailsString.split(',').map(d => d.trim()));
    }

    return {messagePart, detailsPart};
  }

  removeImage(): void {
    this.errorMessages = null;
    this.errorMessagePart = null;
    this.files = null;       // Optionally clear the file data as well
    this.fileImage = null;  // Clear the image source
  }

  exportData(format: string, patientId: string, filename: string) {
    const params = {
      patientId,
      format,
      clientId: this.authService.getClientId()
    };

    this.insuranceServices.getExportFile(null, params).subscribe((response: HttpResponse<Blob>) => {

        try {

          // Create a blob and trigger the download
          const blob = new Blob([response.body!], {
            type: format === 'excel'
              ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              : 'application/pdf'
          });

          const downloadURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = filename; // Use the extracted filename
          link.click();

          // Clean up the object URL
          window.URL.revokeObjectURL(downloadURL);
          swal.fire({
            icon: 'success',
            title: 'Download Successful',
            text: `The file "${filename}" has been downloaded successfully.`,
            timer: 3000,
            timerProgressBar: true
          });
        }catch (error) {
          // Handle any unexpected errors during download
          swal.fire({
            icon: 'error',
            title: 'Download Failed',
            text: 'An unexpected error occurred while processing the file.',
          });
        }
      },
      (error) => {
        // Show error alert on API failure
        swal.fire({
          icon: 'error',
          title: 'Download Failed',
          text: error?.message || 'Unable to download the file. Please try again later.',
        });
      }
    );
  }

  private updateTable(response: any) {
    this.ngZone.run(() => {
      this.tableData = [...(response?.content || response || [])];
      this.totalRecord = response?.totalElements || 0;
      this.totalPagesArray = Array.from(
        { length: response?.totalPages || 0 },
        (_, i) => i + 1
      );

      if (this.paginator) {
        this.paginator.pageIndex = this.pagination.currentPage;
      }

      this.cdr.detectChanges();
    });
  }

  // Get Client data
  _fetchData(type?: any) {

    const params: { [key: string]: any } = {
      page : this.pagination.page,
      size: this.pagination.size,
      officeId: this.selectedOfficeId || 1, // fallback to 1 if not selected
      duplicate: false
      /*startDate:  this.formatStartOfDay(this.tStartDate),
      endDate:  this.formatEndOfDay(this.tEndDate),
      isUserWorkAreaStartDateEndDate: 'true',
      userTimeZone: this.authService.getTimeZone()*/
    };
    const payer:{ [key: string]: any } = {
      page : this.pagination.page,
      size: this.pagination.size,
      isPayerOfficeCount: 'true',
      officeId: this.selectedOfficeId || 1,
    };

    if (this.sortField && this.sortDirection) {
      params.sort = `${this.sortField},${this.sortDirection}`;
    }

    /*if (this.lastUsedFilterParams && Object.keys(this.lastUsedFilterParams).length > 0) {
      params = { ...params, ...this.lastUsedFilterParams };
    }*/

    const filterType = type !== undefined ? type : this.selectedType;

    /*if (filterType === 1) {
      params.isUserWorkArea = true;
      if (this.searchString) {
        params.searchString = this.searchString;
        params.clientId = 1;
      }
    } else if (filterType === 2) {
      params.isUserWorkArea = true;
      params.active = true;
    } else if (filterType === 3) {
      params.isUserWorkArea = true;
      params.active = false;
    }*/

    this.insuranceServices.getHmoListing(params).pipe(first()).subscribe(
      (response: any) => {
        this.updateTable(response);
      },
      (error) => {
        this.tableData = [];
        this.totalRecord = 0;
        this.totalPagesArray = [];
        this.cdr.detectChanges();
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message,
          showConfirmButton: false,
          timer: 5000
        });
      }
    );

    this.insuranceServices.getHmoPayerListing(payer).pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          // console.log('Payor lisiting', response);
          this.tablePayerData = response.content || response;
          this.totalPayerRecord = response?.totalElements;
          this.totalPayerPagesArray = Array.from({ length: response?.totalPages }, (_, i) => i + 1);
          if (this.paginator) {
            this.paginator.pageIndex = this.paginationPayer.currentPage; // Ensure paginator sync
          }
        } else {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: response.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      (error) => {
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message,
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
  }

  toggleDateFilter() {
    this.showMonthFilter = !this.showMonthFilter;
  }

  applyFilter() {
    this.showMonthFilter = false;
    this.changeDate();
  }

  onMonthSelected(date: Date) {
    this.selectedMonth = date;

    // Temporarily prevent document click from closing the dropdown
    this.ignoreDocumentClick = true;

    // Allow "Apply" button to be clicked before dropdown closes
    setTimeout(() => {
      this.ignoreDocumentClick = false;
    }, 200);
  }


  // Call this when interacting with bsDatepicker
  onDatepickerShown() {
    this.ignoreDocumentClick = true;
    setTimeout(() => this.ignoreDocumentClick = false, 500); // brief ignore window
  }

  resetFilter() {
    this.selectedMonth = null;
    this.lastUsedFilterParams = {};
    sessionStorage.removeItem('lastUsedFilterParams');
    this.showMonthFilter = false;
    this.tableData = [];
    this._fetchData();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.ignoreDocumentClick) { return; }

    const clickedInsideDropdown = this.filterDropdown?.nativeElement.contains(event.target);
    const clickedButton = this.filterBtn?.nativeElement.contains(event.target);

    if (!clickedInsideDropdown && !clickedButton) {
      this.showMonthFilter = false;
    }
  }


  changeDate(){

    if (this.selectedMonth) {
      const hmonth = (this.selectedMonth.getMonth() + 1).toString().padStart(2, '0'); // Ensure 2-digit month
      const hyear = this.selectedMonth.getFullYear().toString();

      const params = {
        month: hmonth,
        year: hyear,
        page: 1,  // Ensure this.currentPage is updated
        size: this.pagination.size,
        officeId: this.selectedOfficeId,
      };


      /*this.lastUsedFilterParams = {
        startDate: params.startDate,
        endDate: params.endDate
      }; // Save the current filters

      sessionStorage.setItem('lastUsedFilterParams', JSON.stringify(this.lastUsedFilterParams));*/


      this.insuranceServices.filterHmo(params).pipe(first()).subscribe(
        (response: any) => {
          if (response) {
            this.updateTable(response);
          }
        },
        (error) => {
          // Handle errors
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message || 'Something went wrong!',
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    }
  }

  /*get isDateFilterApplied(): boolean {
    return !!(this.startDate && this.endDate);
  }*/

  // get isDateFilterApplied(): boolean {
  //   return !!(
  //     this.lastUsedFilterParams?.startDate &&
  //     this.lastUsedFilterParams?.endDate
  //   );
  // }



  // Delete record
  // Delete record
  deleteEntry(userId: any) {
    let reqData = {
      id: userId
    };
    swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this record ?',
      icon: 'warning',
      iconColor: 'red',
      showCancelButton: true,
      confirmButtonText: 'Yes !'
    }).then((result) => {
      if (result.isConfirmed) {
        this.userServices.deleteHmo(reqData).pipe(first()).subscribe(
          (response: any) => {
            if (response) {
              this._fetchData(1);
              swal.fire({
                icon: 'success',
                text: 'Record deleted successfully.',
                showConfirmButton: false,
                timer: 2000
              });
            } else {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: 'Something went wrong!',
                showConfirmButton: false,
                timer: 2000
              });
            }
          },
          (error) => {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: 'Failed to communicate with the server!',
              showConfirmButton: false,
              timer: 2000
            });
          });
      }
    });
  }

  // Update entry
  /*    updateEntry = (clientId: any) => {
          this.router.navigate(['client/details/' + clientId]).then();
      }*/

  // Sort form frontend logic
  sortData(sort: Sort) {
    this.sortField = sort.active;
    this.sortDirection = sort.direction === '' ? null : sort.direction;
    if (sort.active === 'apptDate' || sort.active === 'apptTime' || sort.active === 'careerName') {
      this.sortTableLocally(sort);
    } else {
      // Fetch sorted data from the backend for other fields
      this._fetchData(1);
    }
  }

  sortPayerTable(sort: Sort): void {

  this.payerSortField =
    sort.active;

  this.payerSortDirection =
    sort.direction === ''
      ? null
      : sort.direction;

  this.paginationPayer.currentPage = 0;
  this.paginationPayer.page = 1;

  this.fetchPayerCounterData();
  }
  // Function to sort the table locally for apptDate and apptTime
  private sortTableLocally(sort: Sort) {
    const isAsc = sort.direction === 'asc';

    this.tableData.sort((a: any, b: any) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];

      // Handle null or empty values
      if (!valueA) { return 1; }
      if (!valueB) { return -1; }

      // If sorting `apptDate`, ensure proper date sorting
      if (sort.active === 'apptDate') {
        return isAsc
          ? new Date(valueA).getTime() - new Date(valueB).getTime()
          : new Date(valueB).getTime() - new Date(valueA).getTime();
      }

      // If sorting `apptTime`, use string comparison (assuming HH:mm format)
      if (sort.active === 'apptTime') {
        return isAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      // Sorting for `carrierName`
      if (sort.active === 'careerName') {
        return isAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      return 0;
    }); }

  logout() {
    // Clear session storage during logout
    sessionStorage.removeItem('hmoListPage');
    sessionStorage.removeItem('tableListPage');
    this.authService.logout();
  }

  getSelectedPayerName(payerId: any): string {

  if (
    payerId === null ||
    payerId === undefined ||
    payerId === ''
  ) {
    return 'Select Payer';
  }

  const payer = this.payerArray?.find(
    (item: any) =>
      String(item.id) === String(payerId)
  );

  return payer?.name || 'Select Payer';
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
